import { CALENDAR_EVENTS, INVOICES } from "../scoro/apiMethods";

export const createCalendarEventRoute = async (
  event_name,
  start_datetime,
  end_datetime,
  studio_id,
  user_id,
  contact_id,
  session_type,
  duration,
  hourly_price
) => {
  const { invoice_id, invoice_line_id } = await INVOICES.create(
    contact_id,
    user_id,
    duration,
    hourly_price
  );

  const event_id = await CALENDAR_EVENTS.create(
    event_name,
    start_datetime,
    end_datetime,
    studio_id,
    user_id,
    contact_id,
    invoice_id,
    session_type
  );

  //await TIME_ENTRIES.create(event_id, user_id, contact_id, 285, invoice_line_id);

  return true;
};
